const {cxt} = require("./context");

const driversLicenceCardNumber = [
  'whitespace',
  'alphanumeric',
  cxt('min-length', { length: 5 }),
  cxt('max-length', { length: 10 }),
];

const AustralianCapitalTerritory = [
  'whitespace',
  'alphanumeric',
  cxt('min-length', { length: 9 }),
  cxt('max-length', { length: 9 }),
];

const NewSouthWales = [
  'whitespace',
  'alphanumeric',
  cxt('min-length', { length: 8 }),
  cxt('max-length', { length: 8 }),
];

const NorthernTerritory = [
  'whitespace',
  'alphanumeric',
  cxt('min-length', { length: 7 }),
  cxt('max-length', { length: 7 }),
];

const WesternAustralia = [
  'whitespace',
  'alphanumeric',
  cxt('min-length', { length: 7 }),
  cxt('max-length', { length: 7 }),
];

const SouthAustralia = [
  'whitespace',
  'alphanumeric',
  cxt('min-length', { length: 6 }),
  cxt('max-length', { length: 6 }),
];

const Tasmania = [
  'whitespace',
  'alphanumeric',
  cxt('min-length', { length: 7 }),
  cxt('max-length', { length: 7 }),
];

const Queensland = [
  'whitespace',
  'alphanumeric',
  cxt('min-length', { length: 9 }),
  cxt('max-length', { length: 9 }),
];

const Victoria = [
  'whitespace',
  'alphanumeric',
  cxt('min-length', { length: 9 }),
  cxt('max-length', { length: 9 }),
];

module.exports = {
  driversLicenceCardNumber,
  driversLicenceNumber: {
    AustralianCapitalTerritory,
    NewSouthWales,
    NorthernTerritory,
    WesternAustralia,
    SouthAustralia,
    Tasmania,
    Queensland,
    Victoria,
  },
};
